module.exports = "/static/assets/0cb6638e17e8c21c8563bc532a010470.png";